import React from 'react';
import Styled from './styles';
import { getAnnouncementsCount } from '../../../../helpers/announcement';
import { SORT_ON } from '../../../../constants/ANNOUNCEMENT';
import { TriangleUp } from '../../../../shared/components/Announcements/TriangleUp';
import { TriangleDown } from '../../../../shared/components/Announcements/TriangleDown';
import useTranslate from '../../../../hooks/useTranslate';

export const SortAnnouncement = ({ announcementCount, sortOn, setSortOn }) => {
  const { t, i18n } = useTranslate();
  const handleSortOnClick = () => {
    if (sortOn === SORT_ON.ASC) return setSortOn(SORT_ON.DESC);
    if (sortOn === SORT_ON.DESC) return setSortOn(SORT_ON.ASC);
  };

  if (!announcementCount) return null;

  return (
    <Styled.SortWrapper>
      <Styled.AnnouncementCountWrapper>
        <Styled.AnnouncementCount>
          {getAnnouncementsCount(announcementCount, i18n, t)}
        </Styled.AnnouncementCount>
      </Styled.AnnouncementCountWrapper>

      <Styled.SortContainer>
        <Styled.Button onClick={handleSortOnClick}>
          <Styled.TrianglesWrapper>
            <TriangleUp isSelected={sortOn === SORT_ON.ASC} />
            <TriangleDown isSelected={sortOn === SORT_ON.DESC} />
          </Styled.TrianglesWrapper>
          {sortOn === SORT_ON.ASC ? t('price_in_ascending_order') : t('price_in_descending_order')}
        </Styled.Button>
      </Styled.SortContainer>
    </Styled.SortWrapper>
  );
};
